import { end, start } from '@popperjs/core';
import sinon from 'sinon';
var fakes_ran = false;
function setFakeTimers(date = new Date("9/1/26 12:59:59 PM")) {
    if (fakes_ran) {
        return;
    }
    const clock = sinon.useFakeTimers({now:date.getTime(), shouldAdvanceTime:true});
    fakes_ran = true;
    return clock;
}

function getCurrentClass(schedule) {
 //  setFakeTimers();
//  console.log(new Date())
    if (getCurrentDay(new Date()) === -1 && schedule.length !== 5) {
        return [null, null]
    }
    var currentDay;
    if (schedule.length === 5) {
        currentDay = schedule[new Date().getDay() - 1]
    } else {
        currentDay = schedule[getCurrentDay(new Date())]
    }
    if (currentDay === undefined) {
        return [null, null]
    }
  //  console.log(currentDay)
    var currentBlock;
    var nextBlock;
    currentDay.schedule.every(function (block, i) {
        var currentDate = new Date()
        var startDate = new Date(currentDate.getTime());
        startDate.setHours(block.time[0].split(":")[0]);
        startDate.setMinutes(block.time[0].split(":")[1]);
        startDate.setSeconds(0);
        var endDate = new Date(currentDate.getTime());
        endDate.setHours(block.time[1].split(":")[0]);
        endDate.setMinutes(block.time[1].split(":")[1]);
        endDate.setSeconds(0);
        if (currentDate <= startDate) {
            currentBlock = null
            nextBlock = block
            return false;
        }
        if (currentDate >= startDate && currentDate <= endDate) {
            currentBlock = block
            if (i < currentDay.schedule.length - 1) {
                nextBlock = currentDay.schedule[i + 1]
            } else {
                nextBlock = null
            }
            return false;
        }
        return true;
    })
    return [currentBlock, nextBlock]

}
var offdays = [
  ["September 7 2026", "September 7 2026"],
  ["October 9 2026", "October 9 2026"],
  ["October 12 2026", "October 12 2026"],
  ["November 25 2026", "November 27 2026"],
  ["December 18 2026", "December 18 2026"],
  ["December 21 2026", "January 4 2027"],
  ["January 15 2027", "January 15 2027"],
  ["January 18 2027", "January 19 2027"],
  ["February 15 2027", "February 19 2027"],
  ["April 5 2027", "April 12 2027"],
  ["May 31 2027", "May 31 2027"],
  ["June 2 2027", "June 2 2027"],
  ["June 3 2027", "June 3 2027"]
];
function getCurrentDay(today = new Date(), return_closst = false) {
    var start;
    

    if (new Date("1/21/27").getTime() < new Date().getTime()) {
        start = new Date("1/21/27 23:59")
    } else {
        start = new Date("9/1/2026 23:59")
    }
    //console.log(start)
    //const today = new Date("5/30/25")
    const offdays_parsed = offdays.map(e => {
        var startDate = new Date(e[0]+", 0:00")
        var endDate = new Date(e[1]+", 23:59")
        if (startDate.getMonth() > 7) {
            startDate.setFullYear(2026)
        } else {
            startDate.setFullYear(2027)
        }
        if (endDate.getMonth() > 7) {
            endDate.setFullYear(2026)
        } else {
            endDate.setFullYear(2027)
        }
        return [startDate, endDate]
    }
    ) 
    if (today < new Date("9/1/2026") || offdays_parsed.some(e => e[0].getTime() <= today.getTime() && e[1].getTime() >= today.getTime()) || today.getDay() === 0 || today.getDay() === 6) {
        if (!return_closst) {
        return -1;
    }
    }
   // console.log(offdays_parsed)
    var days = 0
    while (start.getTime() < today.getTime()) {
        var day = start.getDay()
        if (day === 0 || day === 6 || offdays_parsed.some(e => e[0].getTime() <= start.getTime() && e[1].getTime() >= start)) {
          //  console.log(start)
            start.setDate(start.getDate() + 1)
            continue;
        }
        start.setDate(start.getDate() + 1)
        days += 1;
    }
  //  console.log(days)
    return days % 8;
}


export { getCurrentClass, getCurrentDay, setFakeTimers };